<template>
  <v-container id="cupones" tag="section">
    <base-v-component heading="Cupones del Negocio " />
    <base-material-card color="indigo" icon="mdi-tag" inline class="px-5 py-3">
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="goAdd()">{{
          formTitle
        }}</v-btn>
        <v-spacer />
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="cupones"
        :loading="loading"
        disable-pagination
      >
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-tooltip top v-if="!!item.activo">
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="loading"
                  @click="cambiarActivo(item)"
                  class="px-2 ml-1"
                  color="green"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Desactivar</span>
            </v-tooltip>
            <v-tooltip top v-else>
              <template v-slot:activator="{ on }">
                <v-btn
                  :loading="loading"
                  @click="cambiarActivo(item)"
                  class="px-2 ml-1"
                  color="red"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Activar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  @click="goEdit(item)"
                  class="px-2 ml-1"
                  color="success"
                  min-width="0"
                  v-on="on"
                  small
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-btn
              class="px-2 ml-1"
              color="red"
              min-width="0"
              small
              @click="deleteItem(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  data() {
    return {
      loading: false,
      headers: [
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      negocio: "app/negocioGestObj",
    }),
    ...mapState({
      cupones: (state) => state.cupones.cupones,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    subtitulo() {
      return "Listado de cupones de " + this.negocio.nombre;
    },
    formTitle() {
      return "Nuevo cupón";
    },
  },
  methods: {
    cambiarActivo(item) {
      return this.$store
        .dispatch("cupones/addCupon", {
          ...item,
          activo: !item.activo,
        })
        .then(() => {
          return this.getCupones();
        });
    },
    getCupones() {
      this.loading = true;
      let _vm = this;
      return this.$store.dispatch("cupones/getCupones").finally(() => {
        _vm.loading = false;
      });
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar el cupón? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("cupones/deleteCupon", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Cupon eliminado",
            });
            _vm.getCupones();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    reload() {
      this.getCupones();
    },
    goAdd() {
      let str = "/admin/gest/" + this.negocio.id + "/cupones/add";
      this.$router.push(str);
    },
    goEdit(item) {
      let str = "/admin/gest/" + this.negocio.id + "/cupones/edit/" + item.id;
      this.$router.push(str);
    },
  },
  mounted() {
    this.getCupones();
  },
};
</script>

<style>
</style>